import React from 'react';
import { Modal } from 'antd';

const BasicModal = (props) => {
    // onCancelTitle - Title of cancel butotn
    // onCancelVisible

    return (
        <>
            <Modal
                autoFocusButton={null}
                destroyOnClose={true}
                className={
                    props.className === undefined
                        ? 'basic-modal'
                        : props.className
                }
                title=""
                visible={props.visible}
                onOk={props.onOk}
                onCancel={props.onCancel}
                footer={props.footer === undefined ? null : props.footer}
                closable={props.closable === undefined ? false : props.closable}
                bodyStyle={
                    props.bodyStyle === undefined
                        ? { height: 572 }
                        : props.bodyStyle
                }
                width={props.width === undefined ? 400 : props.width}
            >
                <div className="icon-container">
                    <img
                        src={props.icon}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div>
                    <div>
                        <p className="header-title">{props.title}</p>
                    </div>
                </div>
                {props.children}
                {props.basicButtonVisible === undefined || true ? (
                    <div style={{ textAlign: 'center', marginTop: '212px' }}>
                        <button
                            onClick={props.onAccept}
                            style={{
                                width: '100%',
                                height: 26,
                                textTransform: 'uppercase'
                            }}
                            className={
                                props.onAcceptClassName === undefined
                                    ? 'ant-btn ant-btn-primary ant-btn-block blue-button'
                                    : props.onAcceptClassName
                            }
                        >
                            {props.onAcceptTitle}
                        </button>
                        <button
                            onClick={props.onCancel}
                            style={{
                                width: '100%',
                                marginTop: 10,
                                color: '#407CB1',
                                height: '26px',
                                backgroundColor: '#fff',
                                border: '1px solid #578CBA',
                                textTransform: 'uppercase'
                            }}
                        >
                            {props.onCancelTitle === undefined
                                ? 'CANCEL'
                                : props.onCancelTitle}
                        </button>
                    </div>
                ) : null}
            </Modal>
        </>
    );
};

export default BasicModal;
